import { useRunTemplateTransport } from "@/templates/transport"

interface TemplateBreadcrumbContentProps {
  templateId: string
  isLast: boolean
}

export function TemplateBreadcrumbContent({
  templateId,
  isLast,
}: TemplateBreadcrumbContentProps) {
  const { data } = useRunTemplateTransport(templateId, {
    enabled: !!templateId && templateId !== "new",
  })

  const displayName = data?.display_name || templateId

  return <span className={isLast ? "font-semibold" : ""}>{displayName}</span>
}
